/* SisMoney: format amounts in the browser EXACTLY as Liquid's
   money_without_trailing_zeros does for this request (code review 2026-09-24).

   Liquid renders a sample, 1234.56, into this script tag's data-sample (see
   snippets/custom-globals.liquid), with the store's whole money format - on
   the live store that is <span class="notranslate ht-money">${{amount_no_decimals}}</span>,
   so the sample reads "$1,235" inside the Hextom wrapper span. From it we learn
   the thousands and decimal separators, whether cents are shown, and the
   wrapper, and reproduce them for any amount. Markets: Liquid renders the
   sample in the request's presentment currency, so the symbol follows too.

   html(amount) -> the full money markup (wrapper included), for price slots
                   that Liquid also fills with | money_without_trailing_zeros;
   text(amount) -> the same without markup, for slots Liquid fills with
                   | strip_html (Save pills, add-on rows).
   Amounts are in major units (dollars). Before this, three blocks each ran
   their own Intl formatter, which printed $139.99 under a $140 header and
   dropped the ht-money wrapper. */
(function () {
  'use strict';
  var script = document.currentScript;
  var sampleHtml = (script && script.dataset.sample) || '';
  var holder = document.createElement('div');
  holder.innerHTML = sampleHtml;
  var sampleText = holder.textContent || '';
  // "1,235" | "1,234.56" | "1.234,56" | "1 234,56" | "1'234.56" | "1234.56" ...
  var m = sampleText.match(/1([^0-9]?)23([45])(?:([^0-9])(\d{2}))?/);

  function group(intPart, sep) {
    return sep ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : intPart;
  }

  function amountString(n) {
    var thousands = m[1];
    var decimals = m[2] === '4' && m[3] ? 2 : 0;
    var decimalSep = m[3] || '.';
    var fixed = Math.abs(n).toFixed(decimals).split('.');
    var out = group(fixed[0], thousands);
    // money_without_trailing_zeros: $15.00 -> $15
    if (decimals && fixed[1] !== '00') out += decimalSep + fixed[1];
    return (n < 0 ? '-' : '') + out;
  }

  function fallback(n) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        minimumFractionDigits: Math.abs(n - Math.round(n)) < 0.005 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2).replace(/\.00$/, '');
    }
  }

  window.SisMoney = {
    html: function (n) {
      if (!m) return fallback(n);
      return sampleHtml.replace(m[0], amountString(n));
    },
    text: function (n) {
      if (!m) return fallback(n);
      return sampleText.replace(m[0], amountString(n));
    },
  };
})();
